import React, { useState } from 'react';
import axios from 'axios';
import '../App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CreateJamModal = ({ isOpen, onClose, onSessionCreated, userToken }) => {
  console.log('🎨 CreateJamModal rendering, isOpen:', isOpen);
  
  const [sessionName, setSessionName] = useState('');
  const [isPublic, setIsPublic] = useState(true);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) {
    console.log('🚫 Modal not open, returning null');
    return null;
  }

  const handleCreate = async () => {
    if (!sessionName.trim()) {
      setError('Please enter a session name');
      return;
    }

    setCreating(true);
    setError('');

    try {
      const response = await axios.post(
        `${API}/jam/create`,
        {
          name: sessionName,
          is_public: isPublic
        },
        {
          headers: {
            'Authorization': `Bearer ${userToken}`
          }
        }
      );

      console.log('✅ Jam session created:', response.data);
      onSessionCreated(response.data);
      setSessionName('');
      onClose();
    } catch (err) {
      console.error('❌ Failed to create session:', err);
      setError(err.response?.data?.detail || 'Failed to create session');
    } finally {
      setCreating(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="jam-modal-overlay" onClick={onClose}>
      <div className="jam-modal-content create-jam-modal" onClick={(e) => e.stopPropagation()}>
        <div className="jam-modal-header">
          <h2>🎵 Start a Jam Session</h2>
          <button className="jam-modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="jam-modal-body">
          <div className="jam-form-group">
            <label htmlFor="session-name">Session Name</label>
            <input
              id="session-name"
              type="text"
              value={sessionName}
              onChange={(e) => setSessionName(e.target.value)}
              placeholder="Late Night House Vibes 🎧"
              className="jam-input"
              maxLength={50}
            />
          </div>

          <div className="jam-form-group">
            <label className="jam-checkbox-label">
              <input
                type="checkbox"
                checked={isPublic}
                onChange={(e) => setIsPublic(e.target.checked)}
                className="jam-checkbox"
              />
              <span>Public Session (anyone can join)</span>
            </label>
            <p className="jam-help-text">
              {isPublic 
                ? '🌍 Your session will be visible to everyone' 
                : '🔒 Only people with the link can join'}
            </p>
          </div>

          {error && (
            <div className="jam-error-message">
              {error}
            </div>
          )}
        </div>

        <div className="jam-modal-footer">
          <button 
            className="jam-btn jam-btn-secondary" 
            onClick={onClose}
            disabled={creating}
          >
            Cancel
          </button>
          <button 
            className="jam-btn jam-btn-primary" 
            onClick={handleCreate}
            disabled={creating || !sessionName.trim()}
          >
            {creating ? 'Creating...' : '🎵 Start Jamming'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateJamModal;
